module.exports = __webpack_public_path__ + "static/media/recycling.bf0f7266.png";